import Image from "next/image";
import { TEAM } from "@/containers/framerlanding/About";

export default function FullTeamDesktop() {
  return (
    <div className="mb-12">
      <h4 className="text-xl font-bold text-gray-900 mb-4 md:mb-6 text-center">
        De ontwikkelaars achter WisWiz
      </h4>
      <div className="grid grid-cols-4 gap-2 md:gap-4">
        {TEAM.map((member) => (
          <a
            key={member.name}
            href={member.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-gray-50 rounded-lg shadow-sm p-2 md:p-3 text-center transition-all hover:shadow-md focus:outline-none focus:ring-2 focus:ring-info/40 flex flex-col items-center justify-center"
            aria-label={`LinkedIn van ${member.name}`}
          >
            <div className="relative w-12 h-12 md:w-14 md:h-14 mx-auto mb-1 md:mb-2 overflow-hidden rounded-full">
              <div className="absolute inset-0 rounded-full border-2 border-info"></div>
              <Image
                src={member.image}
                alt={member.name}
                width={56}
                height={56}
                className="rounded-full object-contain p-1 w-full h-full"
              />
            </div>
            <div className="flex items-center justify-center gap-1">
              <h5 className="text-xs md:text-sm font-bold text-gray-800">
                {member.name}
              </h5>
              <span className="inline-flex items-center text-info" aria-hidden>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="w-3 h-3 md:w-4 md:h-4"
                >
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-10h3v10zm-1.5-11.141c-.966 0-1.75-.79-1.75-1.766s.784-1.767 1.75-1.767 1.75.791 1.75 1.767-.783 1.766-1.75 1.766zm13.5 11.141h-3v-5.604c0-1.336-.027-3.055-1.861-3.055-1.861 0-2.146 1.453-2.146 2.955v5.704h-3v-10h2.879v1.367h.041c.401-.76 1.379-1.561 2.84-1.561 3.04 0 3.6 2.003 3.6 4.609v5.585z" />
                </svg>
              </span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
